import { css, CSSResult } from 'lit'
import { SCREENS } from '@cloudsuite/mosaic-shared/styles/breakpoints.js'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'


export const cscBasketHeaderButton = {
  badgeOffset: css`var(--csc-basket-header-button-badge-offset, 11px)`,
}

export const style: CSSResult = css`
  .header-button {
    display: inline-grid;
    grid-template-columns: auto auto;
    justify-items: center;
    align-items: end;
    column-gap:${csSpacing.spacing04};
  }

  .header-button cse-group {
    z-index: 1;
    margin-top: calc(-1 * ${cscBasketHeaderButton.badgeOffset});
  }

  svg {
    fill: var(--cse-button-primary-color);
  }

  @media (width < ${SCREENS.medium}) {
    cse-group {
      text-align: right;
    }
  }
`
